{
  "overview": {
    "no_clusters": "Dieses Projekt hat noch keine Cluster. Sie können neue Cluster über den Erstellen Knopf rechts oben anlegen!",
    "table": {
      "instances": "Instanzen",
      "tooltips": {
        "details": "Details",
        "clone": "Duplizieren (Noch nicht implementiert)",
        "delete": "Löschen",
        "namespace": "Der Kubernetes-Namespace, in dem dieser Service bereitgestellt wird.",
        "supportPlan": "Das Level an Support, welches für diesen Service ausgewählt wurde.",
        "instances": "Die Anzahl der aktiven Instanzen dieses Services.",
        "status": "Der Status spiegelt den Zustand und die Verfügbarkeit dieses Services wider."
      }
    },
    "modals": {
      "delete": {
        "title": "Cluster löschen",
        "content_text": "Sind Sie sicher, dass Sie den Cluster löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden."
      }
    }
  },
  "details": {
    "new_information_applied": "Neue Informationen wurden angewandt",
    "could_not_retrieve_cluster_data": "Es ist ein Fehler aufgetreten. Die Cluster Informationen konnten nicht geladen werden.",
    "header": {
      "replica": "Instanzen",
      "desired_replica": "{{count}} Soll-Replikate",
      "storage": "Speicher",
      "storage_used": "Genutzter Speicher",
      "cluster_is_creating": "Der Cluster wird gerade erstellt.",
      "cluster_is_updating": "Der Cluster wird gerade aktualisiert.",
      "cluster_is_unavailable": "Der Cluster ist momentan nicht erreichbar.",
      "this_may_take_a_few_minutes": "Dies kann ein paar Minuten dauern.",
      "upgrade_tooltip": "Auf nächste Version aktualisieren",
      "upgrade_in_progress_tooltip": "Upgrade läuft",
      "upgrade_scheduled_tooltip": "Upgrade bereits geplant",
      "create_from_backup": "Aus Sicherung erstellen",
      "restore_from_backup": "Aus Sicherung wiederherstellen",
      "name": {
        "move": "In ein anderes Projekt verschieben",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "submit": "Speichern"
      },
      "delete": "Löschen",
      "favorite": {
        "add": "Zu Favoriten hinzufügen",
        "remove": "Aus Favoriten entfernen"
      },
      "delete_disable_reason": {
        "being_cloned_already": "Dieser Cluster wird gerade geklont und kann nicht gelöscht werden."
      },
      "manage": "Editieren",
      "backups_not_available": "Kontinuierliche Backups sind deaktiviert. Sie können aus diesem Cluster nicht einen Neuen erstellen",
      "backups_scheduled": "Es gibt noch keine Backups",
      "backups_available": "Cluster aus Backup erstellen",
      "move_not_available": "Der Cluster kann während der Erstellung nicht verschoben werden",
      "redirect_now": "Jetzt weiterleiten",
      "edit_form": {
        "title": "Cluster Editieren",
        "name": "Name",
        "description": "Beschreibung",
        "project": "Projekt"
      },
      "raiseTicket": "Ticket erstellen",
      "upgrade_version_form": {
        "title": "Upgrade auf PostgreSQL {{version}}",
        "warning_no_backup": "<b>Für diesen Cluster wurden keine Backups gefunden.</b>",
        "warning_latest_backup": "<b>Das letzte Cluster-Backup wurde am {{dateTime}} abgeschlossen.</b>",
        "warning_message": "Bevor Sie mit dem Upgrade fortfahren, stellen Sie bitte sicher, dass ein aktuelles vollständiges Cluster-Backup verfügbar ist.",
        "confirm_message": "Sie versuchen, das Upgrade außerhalb des definierten Wartungsfensters durchzuführen. Wenn Sie fortfahren, wird es automatisch für das nächste Wartungsfenster <b>{{maintenanceWindows}} UTC</b> geplant.",
        "confirm_question": "Möchten Sie mit dem Upgrade fortfahren?",
        "submit": "Upgrade durchführen"
      },
      "restore_form": {
        "title": "Cluster wiederherstellen",
        "tooltip": "Geben Sie einen Backup-Zeitstempel ein oder wählen Sie einen aus der Liste verfügbarer Backups aus",
        "backup_label": "Backup auswählen",
        "backup_tooltip": "Bei Auswahl eines Backups wird dessen Zeitstempel verwendet",
        "show_more_options": "Mehr Backups anzeigen",
        "show_less_options": "Weniger Backups anzeigen",
        "warning_message": "Das Wiederherstellen des Clusters aus einer Sicherung überschreibt die vorhandenen Daten. Alle Änderungen, die nach der Erstellung der Sicherung vorgenommen wurden, gehen verloren.",
        "restore_button": "Wiederherstellen"
      }
    },
    "summary": {
      "title": "Übersicht",
      "copy": "Kopieren",
      "copied": "Kopiert!",
      "show": "Anzeigen",
      "hide": "Verstecken"
    },
    "parameters": {
      "title": "Parameter",
      "field_menu": {
        "copy_prop_name": "Name kopieren",
        "copy_prop_value": "Wert kopieren"
      },
      "warning": {
        "postmaster_warn": "Das Ändern dieser Einstellung wird die Datenbank neu starten.",
        "sync_failed": "Diese Konfiguration wird momentan angewendet. Aktueller Wert: {{value}}"
      },
      "collapse_titles": {
        "general": "Allgemein",
        "optimizerSettings": "Optimizer",
        "logfiles": "Logging",
        "statsCollection": "Statistiken",
        "autovacuum": "Autovakuum",
        "miscellaneous": "Verschiedenes"
      },
      "errors": {
        "maximum": "Sollte <= {{limit}} sein",
        "minimum": "Sollte >= {{limit}} sein",
        "multipleOf": "Sollte ein Vielfaches von {{multipleOf}} sein",
        "type": {
          "number": "Sollte eine Nummer sein",
          "integer": "Sollte eine ganze Zahl sein"
        }
      }
    },
    "replicas": {
      "title": "Nodes",
      "instance": "Instanz",
      "role": "Rolle",
      "lag": "Lag",
      "status": "Status",
      "storage_usage": "{{used}} ({{usedPercent}}%) / {{initial}}",
      "logs": "Logs",
      "actions": "Aktionen",
      "roles": {
        "replica": "Replikat",
        "primary": "Primär",
        "pending": "Ausstehend"
      },
      "download": {
        "title": "Geben Sie das maximale Alter der Logeinträge an",
        "form": {
          "time": "Zeit",
          "units": {
            "sec": "Seconds",
            "min": "Minutes",
            "hour": "Hours"
          },
          "buttons": {
            "cancel": "Cancel",
            "submit": "Download"
          }
        }
      },
      "add_replica": {
        "title": "Replikat hinzufügen",
        "confirm": "Sind Sie sicher, dass Sie dem Cluster ein weiteres Replikat hinzufügen möchten?"
      },
      "restart": {
        "title": "Sind Sie sicher, dass Sie die Instanz {{instanceId}} ({{instanceRole}}) neustarten möchten? Dies wird alle offenen Verbindungen trennen und kann einige Zeit in Anspruch nehmen.",
        "cancel_button_label": "Abbrechen"
      },
      "download_tooltip": "Logs herunterladen",
      "show_logs_tooltip": "Logs anzeigen",
      "hide_logs_tooltip": "Logs ausblenden",
      "restart_tooltip": "Instanz neustarten",
      "restart_tooltip_disabled": "Die Instanz kann nur neugestartet werden wenn sie und der Cluster Aktiv sind"
    },
    "load_balancing": {
      "title": "Load Balancing",
      "master_load_balancing": "Master Load Balancing",
      "replica_load_balancing": "Replikat Load Balancing"
    },
    "backups": {
      "size_history_title": "Backup-Größenverlauf",
      "no_size_history": "Keine Backups für den ausgewählten Zeitraum oder zu wenig Daten für die Anzeige des Backup-Histogramms",
      "title": "Backups",
      "backup_now": "Backup erstellen",
      "backup_now_in_progress": "Ihr Backup wird gerade erstellt. Es kann ein paar Minuten dauern, bis es in der Liste erscheint.",
      "backup_now_terminating": "Backup wird abgebrochen",
      "backup_now_cancel": "Backup abbrechen",
      "backup_schedule": "Logische Backups aktivieren",
      "your_local_time": "Lokale Zeit",
      "server_time": "Server Zeit",
      "table": {
        "name": "Name",
        "date": "Datum",
        "size": "Größe",
        "actions": {
          "download": "Herunterladen"
        }
      },
      "logical": "Logisch",
      "continuous": "Kontinuierlich",
      "backups_time": "Backup Zeitpunkt",
      "cycle": "Cyklus",
      "next_backup_scheduled": "Nächstes Backup um",
      "next_logical_backup_scheduled": "Nächstes logische Backup um",
      "next_continuous_backup_scheduled": "Nächstes kontinuierliche Backup um",
      "backups_list": "Backup Liste",
      "continuous_backups_tab_title": "Kontinuierliche Backups aktivieren",
      "retention_period": "Aufbewahrungsfrist",
      "retention_period_not_valid": "Die Aufbewahrungsfrist muss zwischen 2 und 60 liegen.",
      "oldest_possible_restore_point": "Ältester Restore-Zeitpunkt",
      "no_backups_scheduled": "Es werden keine neuen Backups erstellt",
      "days": "Tage",
      "backup_size": "Totale Backupgröße: {{currentSize}}",
      "base_backup_size": "Totale Basis-Backup-Größe: {{currentBaseSize}}",
      "delete_all_backups": "Alle löschen",
      "want_delete_backup": "Sind Sie sicher, dass Sie das Backup {{name}} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "want_delete_all_backups": "Sind Sie sicher, dass Sie alle Backups löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "want_to_cancel_backup_now": "Sind Sie sicher, dass Sie das die Erstellung des Backups abbrechen möchten?",
      "no_base_backup": "Es wurde noch kein Basis-Backup erstellt.",
      "confirm_disable_continuous_backups": "Das Deaktivieren der kontinuierlichen Backups wird alle Basis-Backups und WAL Dateien permanent löschen. Sind Sie sicher, dass Sie fortfahren möchten?",
      "no_backups": "Es gibt derzeit keine Backups"
    },
    "storage": {
      "title": "Speichernutzung",
      "used": "In Verwendung",
      "usage": "Benutzt",
      "available": "Verfügbar",
      "error": {
        "title": "Speicherverbrauch momentan nicht verfügbar",
        "annotation": "Sie können dennoch den Speicherverbrauch der einzelnen <nodeLink>Knoten</nodeLink> einsehen"
      }
    },
    "acl": {
      "title": "ACL",
      "firewall": {
        "title": "Firewall-Einstellungen",
        "max_limit": "Du hast die maximale Anzahl erlaubter IP-Adressen erreicht",
        "warning": "Standardmäßig ist der erlaubte Quellbereich auf 0.0.0.0/32 gesetzt (kein eingehender Zugriff). Aktualisieren Sie diese Einstellung auf Ihre IP-Adresse (z.B. 204.0.93.5/32), um extern auf den Cluster zugreifen zu können",
        "form": {
          "allowed_source_ranges": "Zulässige Quellbereiche",
          "hint": "Gib die Netzwerkbereiche im CIDR-Format an (z. B. <b>192.168.0.1/32</b>), die auf diesen Dienst zugreifen dürfen. Nur Datenverkehr aus diesen Quellen wird zugelassen",
          "ip_address": "IP-Adresse",
          "actions": {
            "remove": "IP-Adresse entfernen",
            "add": "IP-Adresse hinzufügen"
          }
        }
      },
      "pg_hba": {
        "title": "PG HBA"
      },
      "connection_type": "Verbindungstyp",
      "database": "Datenbank",
      "user": "Benutzer",
      "address": "Adresse",
      "auth_method": "Methode",
      "no_acl_rules_warning": "Vorsicht! Falls Sie alle Einträge entfernen werden Sie sich nicht zur Datenbank verbinden können!",
      "validation": {
        "type": {
          "empty": "Wählen Sie einen Typ aus"
        },
        "database": {
          "empty": "Geben Sie eine Datenbank an",
          "not_valid": "Anführungszeichen sind nicht erlaubt"
        },
        "user": {
          "empty": "Geben Sie einen Benutzer an",
          "not_valid": "Anführungszeichen sind nicht erlaubt"
        },
        "address": {
          "empty": "Geben Sie eine Adresse an",
          "not_valid": "Ungültige Adresse"
        }
      }
    },
    "current_replicas": "Aktuelle Replikate",
    "desired_replicas": "Soll-Replikate",
    "datasets": {
      "title": "Datensets",
      "no_datasets": "Es gibt noch keine Datensets",
      "table": {
        "name": "Name",
        "import_date": "Import Datum",
        "status": "Status",
        "schema": "Schema",
        "category": "Kategorie",
        "import_type": "Import Typ",
        "database": "Datenbank",
        "dataset": "Datenset",
        "permission": "Berechtigung",
        "actions": "Aktionen",
        "operation_type": "Typ",
        "result": "Resultat",
        "import_start": "Import Start",
        "import_end": "Import Ende"
      },
      "import": "Datenset importieren",
      "dataset": {
        "import_status": {
          "idle": "Untätig",
          "pending": "Ausstehend",
          "importing": "Importiert",
          "aborting": "Bricht ab",
          "idle_present": "Verfügbar",
          "idle_not_present": "Fehlt"
        },
        "status": {
          "pending": "Ausstehend",
          "importing": "Importiert",
          "successful": "Erfolgreich",
          "aborted": "Abgebrochen",
          "failure": "Fehler",
          "idle": "Idle",
          "error": "Fehler",
          "credentials_invalid": "Ungültige Zugangsdaten",
          "database_not_found": "Datenbank fehlt",
          "schema_exists": "Schema Konflikt",
          "insufficient_space": "Unausreichender Speicherplatz"
        },
        "import_type": {
          "readonly": "Schreibgeschützt",
          "not_readonly": "Editierbar"
        },
        "operation_type": {
          "import": "Import",
          "editable": "Besitzerwechsel"
        },
        "no_imports_in_database": "Diese Datenbank besitzt keine importierten Datensets.",
        "cancel": "Abbrechen",
        "reimport": "Erneut importieren",
        "delete": "Löschen",
        "action_disable_reason": {
          "schema_conflict": "Es existiert ein anderes Schema mit demselben Namen, weshalb ein erneuter Import nicht möglich ist.",
          "reimport_drop_schema_first": "Um ungewollten Datenversult zu vermeiden ist der erneute Import von editierbaren Datensets nicht gestattet. Bitte versichern Sie sich, dass Sie keine wichtigen Daten in diesen Schema speichern und löschen Sie es manuell.",
          "delete_drop_schema_first": "Um ungewollten Datenversult zu vermeiden ist das Löschen von editierbaren Datensets nicht gestattet. Bitte versichern Sie sich, dass Sie keine wichtigen Daten in diesen Schema speichern und löschen Sie es manuell."
        },
        "set_not_readonly": "Editierbar machen",
        "delete_confirm_message": "Sie Sie sicher, dass Sie das Datenset {{datasetName}} löschen möchten? Da diesen Datenset auf der Datenbank fehlt wird nur die Historie gelöscht.",
        "cancel_confirm_message": "Sind Sie sicher, dass Sie den Import vom Datenset {{dataset_name}} abbrechen möchten?",
        "reimport_confirm_message": "Sind Sie sicher, dass Sie das Datenset {{dataset_name}} erneut importieren möchten? Referenzen auf dieses Schema werden dadurch verloren.",
        "set_not_readonly_confirm_message": "Sind Sie sicher, dass Sie das Datenset {{dataset_name}} editierbar machen möchten?"
      },
      "overlay": {
        "title": "Datensets importieren",
        "buttons": {
          "import": "Importieren",
          "cancel": "Abbrechen"
        }
      }
    },
    "members": {
      "title": "Mitglieder",
      "list": {
        "title": "Mitglieder",
        "you": "Sie",
        "no_members": "Es gibt keine Mitglieder",
        "form": {
          "empty_list": "Mitgliederliste ist leer",
          "search": {
            "no_results": "Es wurde nichts gefunden"
          }
        }
      }
    },
    "application": {
      "title": "Applikation",
      "open_in_new_tab": "Anwendung in neuem Tab öffnen"
    },
    "lifecycle_state": {
      "stop_confirm_message": "Bist du sicher, dass du diesen Service stoppen möchtest?",
      "start_confirm_message": "Bist du sicher, dass du diesen Service starten möchtest?",
      "stop_tooltip": "Service stoppen",
      "start_tooltip": "Service starten"
    }
  },
  "price_estimation": {
    "instance": "Instanz",
    "replicas": "Replikate",
    "cores": "CPU",
    "memory": "Arbeitsspeicher",
    "storage": "Massenspeicher",
    "specs": {
      "cores": "{{count}} Kern",
      "cores_plural": "{{count}} Kerne",
      "memory_gb": "{{count}} GB",
      "storage_gb": "{{count}} GB"
    },
    "support_plan": {
      "title": "Support-Plan",
      "name": "Name",
      "description": "Beschreibung"
    },
    "periods": {
      "per_month": "pro Monat",
      "per_day": "pro Tag"
    },
    "total": "Total"
  },
  "create": {
    "cluster_created": "Der Cluster wurde erfolgreich erstellt",
    "stepper": {
      "general": "Allgemein",
      "plan": "Plan",
      "summary": "Übersicht"
    },
    "selector": {
      "submit_button": {
        "pending": "Wähle einen Service aus",
        "loading": "Service wird überprüft...",
        "pass": "Weiter",
        "fail": "Ungeeigneter Service"
      },
      "tooltips": {
        "unsuitable_service_type": "Unpassender Service-Typ.",
        "continuous_backups_not_enabled": "Kontinuierliche Backups sind auf diesem Service nicht aktiviert.",
        "no_oldest_restore_point": "Der Service verfügt noch über keine Base-Backups.",
        "service_is_creating": "Der Service wird noch erstellt.",
        "failed_to_get_service_state": "Während des Abrufens des Service-Statuses ist ein Fehler aufgetreten."
      }
    },
    "form": {
      "allow_all_connections": "Alle Verbindungen erlauben"
    },
    "plan": {
      "hour": "Stunde",
      "gbs": "{{count}} GB",
      "cpu": "Kerne",
      "choose_compute_plan": "Wählen Sie einen Leistungsplan",
      "choose_storage_plan": "Wählen Sie einen Speicherplan"
    },
    "summary": {
      "title": "Preis pro Monat",
      "compute_plan_name": "Art",
      "price_per_instance": "Pro Instanz",
      "replicas": "Replikate",
      "total": "Total"
    }
  },
  "plan": {
    "change_plan": "Plan ändern",
    "title": "Plan",
    "cancel": "Abbrechen",
    "submit": "Speichern",
    "current": "Aktuell",
    "deprecated": "Aktuell (veraltet)",
    "disable_reasons": {
      "tiny": "Plan zu klein",
      "large": "Plan zu groß",
      "storage": {
        "different": "Anderes Speichermedium",
        "tiny_and_different": "Plan zu klein und von anderem Speichermedium"
      }
    },
    "pgConfig": {
      "title": "Empfohlene PostgreSQL Parameter",
      "noSuggestions": "Basierend auf Ihren gewählten Cluster-Resourcen gibt es derzeit keine Empfehlungen.",
      "unchangedWarning": "Wird dieser Parameter nicht verändert, überschreitet er die vorgeschlagenen Grenzen dieser Einstellung."
    }
  },
  "advice": {
    "title": "Empfehlungen",
    "severitySummary": {
      "NOTICE": "Der Zustand Ihrer Datenbank ist <1>hervorragend</1>.<br/>Es sind keine sofortigen Maßnahmen erforderlich, jedoch stehen Erkenntnisse zur Verfügung.",
      "REMARK": "Der Zustand Ihrer Datenbank ist insgesamt <1>gut</1>, es wurden jedoch einige kleinere Empfehlungen erkannt.",
      "LOW": "Ihre Datenbank ist <1>stabil</1>, jedoch werden Optimierungen zur Verbesserung von Leistung oder Sicherheit empfohlen.",
      "MEDIUM": "Der Zustand Ihrer Datenbank weist <1>mittlere</1> Probleme auf.<br/>Wir empfehlen, die Vorschläge zu überprüfen und umzusetzen.",
      "HIGH": "Ihre Datenbank weist <1>schwerwiegende</1> Probleme auf.<br/>Es wird empfohlen, umgehend Maßnahmen zu ergreifen.",
      "SHOWSTOPPER": "Der aktuelle Zustand Ihrer Datenbank wird als <1>kritisch</1> eingestuft.<br/>Wir empfehlen dringend, die Empfehlungen von Scalefield umzusetzen."
    },
    "labels": {
      "createdAt": "Erkannt",
      "type": "Modul",
      "object": "Objekt",
      "subobject": "Subobjekt",
      "info": "Zusammenfassung",
      "text": "Begründung",
      "detail": "Details",
      "script": "Skript",
      "furtherReading": "Weiterführende Informationen"
    },
    "table": {
      "noAdvice": "Keine Probleme erkannt. Ihre Datenbank ist in einwandfreiem Zustand!",
      "actions": "Aktionen",
      "dismiss": "Empfehlung ausblenden"
    },
    "info": {
      "title": "Empfehlungsdetails",
      "scriptAvailable": "Automatische Behebung",
      "scriptAvailableTooltip": "Dieses Problem kann automatisch mit dem bereitgestellten Skript behoben werden.",
      "furtherReadingAvailable": "Mehr erfahren",
      "furtherReadingAvailableTooltip": "Externe Ressource für weiterführende Informationen verfügbar.",
      "cancelButton": "Schließen"
    },
    "modules": {
      "MODULE_BLOAT": "Aufblähung",
      "MODULE_COLLECT_STATS": "Statistiken sammeln",
      "MODULE_CONFIG": "Konfiguration",
      "MODULE_INDEX_ANOMALIES": "Index-Anomalien",
      "MODULE_RUNTIME": "Laufzeit",
      "MODULE_SAMPLE": "Stichprobe",
      "MODULE_SECURITY": "Sicherheit",
      "MODULE_STORAGE": "Speicher",
      "MODULE_TABLE_ANOMALIES": "Tabellenanomalien",
      "MODULE_VARIOUS": "Verschiedenes"
    },
    "severities": {
      "NOTICE": "Hinweis",
      "REMARK": "Anmerkung",
      "LOW": "Niedrig",
      "MEDIUM": "Mittel",
      "HIGH": "Hoch",
      "SHOWSTOPPER": "Kritisch"
    },
    "status": {
      "running": "AKTIV",
      "succeeded": "ERFOLG",
      "failed": "FEHLER",
      "unknown": "FEHLER"
    },
    "rerun_check": "Prüfung erneut ausführen",
    "confirm_rerun_check": "Sind Sie sicher, dass Sie eine Datenbankprüfung starten möchten?",
    "last_check": "Letzte Prüfung: <1>{{datetime}}</1>",
    "not_found": "nicht gefunden",
    "ignored_advice": "Sie haben eine ausgeblendete Empfehlung.",
    "ignored_advice_plural": "Sie haben {{count}} ausgeblendete Empfehlungen.",
    "undo_ignored_advice": "Alle wiederherstellen"
  },
  "instance": "{{count}} Instanz",
  "instance_plural": "{{count}} Instanzen",
  "search": "Suchen",
  "type": "Typ",
  "status": "Status",
  "name": "Name",
  "description": "Beschreibung",
  "generate_new": "Neu generieren",
  "create_new": "Erstellen",
  "apply": "Speichern",
  "reset": "Zurücksetzen",
  "submit": "Speichern",
  "master": "Primär",
  "babelfish": "Babelfish",
  "load_balancer_for_replicas": "Load balancer für Replikate",
  "utc": "UTC",
  "cluster_filter_no_data": "Es gibt keine Cluster die Ihrem Filter entsprechen.",
  "no_clusters": "Dieses Projekt hat noch keine Cluster",
  "loading_please_wait": "Der Cluster wird momentan initialisiert.<br/>Dies dauert ein paar Minuten, bitte haben Sie Geduld...",
  "enter_fullscreen_tooltip": "Vollbildmodus aktivieren",
  "exit_fullscreen_tooltip": "Vollbildmodus beenden"
}
